export default __webpack_public_path__ + "static/media/promptHeaderImage.217dc327.png";